const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

const setJwt = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

const setRefreshJwt = (token) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};


const getJwt = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token !== null && token !== undefined) {
    return token;
  } else {
    return null;
  }
};

const getRefreshJwt = () => {
  const token = localStorage.getItem(REFRESH_TOKEN_KEY);
  if (token !== null && token !== undefined) {
    return token;
  } else {
    return null;
  }
};

const removeJWT = () => {
  localStorage.removeItem(TOKEN_KEY);
   removeRefreshJWT();
};

const removeRefreshJWT = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

const isValidToken = () => {
  const token = getJwt();
  if (!token) {
    return false;
  }
  return true;
};

const jwt= {
  setJwt,
  setRefreshJwt,
  getJwt,
  getRefreshJwt,
  removeJWT,
  removeRefreshJWT,
  isValidToken,
};

export default jwt;